export class PersonRel {
	id: number;
	local_id: string;
	contribuente: string;
	associato: string;
	qualifica_associato_id: string;
	comune_id: string;
	cognome: string;
	nome: string
	codice_fiscale: string;
	qualifica_associato: string;

	constructor(id: any = null){
		this.id = id;
		this.local_id = '';
		this.clear();
	}

	clear(){
		this.associato = '';
		this.qualifica_associato_id = '';
		this.comune_id = '';
		this.cognome = '';
		this.nome = '';
		this.codice_fiscale = '';
		this.qualifica_associato = '';
	}
}
